"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var userConfigurationDictionaryEntry_1 = require("owa-service/lib/factory/userConfigurationDictionaryEntry");
var userConfigurationDictionaryObject_1 = require("owa-service/lib/factory/userConfigurationDictionaryObject");
var getUserConfiguration_1 = require("owa-session-store/lib/actions/getUserConfiguration");
var updateUserConfiguration_1 = require("owa-session-store/lib/services/updateUserConfiguration");
var legacy_1 = require("satcheljs/lib/legacy");
/**
 * Expand or collapse the Favorites tree ty setting the store isExpand value
 */
exports.default = legacy_1.action('toggleFavoritesTreeExpansion')(function toggleFavoritesTreeExpansion() {
    var userOptions = getUserConfiguration_1.default().UserOptions;
    userOptions.IsFavoritesFolderTreeCollapsed = !userOptions.IsFavoritesFolderTreeCollapsed;
    updateUserConfiguration_1.default('OWA.UserOptions', [
        userConfigurationDictionaryEntry_1.default({
            DictionaryKey: userConfigurationDictionaryObject_1.default({
                Type: 'String',
                Value: ['IsFavoritesFolderTreeCollapsed'],
            }),
            DictionaryValue: userConfigurationDictionaryObject_1.default({
                Type: 'Boolean',
                Value: [String(userOptions.IsFavoritesFolderTreeCollapsed)],
            }),
        }),
    ]);
});
//# sourceMappingURL=toggleFavoritesTreeExpansion.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-favorites-store/lib/actions/toggleFavoritesTreeExpansion.js
// module id = 4658
// module chunks = 14